// Sport-aware pitch/court background rendered as an SVG (viewBox 0..100 portrait).
// Home attacks upward. Falls back to a generic field for unmapped sports.
const FIELD = ["soccer", "rugby", "hockey", "handball", "lacrosse", "american_football", "field_hockey"];
const COURT = ["basketball", "volleyball", "tennis", "badminton", "netball"];

const LINE = "rgba(255,255,255,0.6)";

function FieldPitch() {
  return (
    <svg viewBox="0 0 100 150" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" style={{ background: "linear-gradient(180deg,#166534,#15803d)" }}>
      <rect x="4" y="4" width="92" height="142" fill="none" stroke={LINE} strokeWidth="0.8" />
      <line x1="4" y1="75" x2="96" y2="75" stroke={LINE} strokeWidth="0.8" />
      <circle cx="50" cy="75" r="12" fill="none" stroke={LINE} strokeWidth="0.8" />
      <circle cx="50" cy="75" r="1" fill={LINE} />
      {/* penalty boxes */}
      <rect x="28" y="4" width="44" height="20" fill="none" stroke={LINE} strokeWidth="0.8" />
      <rect x="40" y="4" width="20" height="8" fill="none" stroke={LINE} strokeWidth="0.8" />
      <rect x="28" y="126" width="44" height="20" fill="none" stroke={LINE} strokeWidth="0.8" />
      <rect x="40" y="138" width="20" height="8" fill="none" stroke={LINE} strokeWidth="0.8" />
    </svg>
  );
}

function CourtPitch({ sport }) {
  const net = sport === "volleyball" || sport === "tennis" || sport === "badminton";
  return (
    <svg viewBox="0 0 100 150" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" style={{ background: "linear-gradient(180deg,#9a5b28,#b3702f)" }}>
      <rect x="5" y="5" width="90" height="140" fill="none" stroke={LINE} strokeWidth="1" />
      <line x1="5" y1="75" x2="95" y2="75" stroke={LINE} strokeWidth={net ? "1.6" : "1"} strokeDasharray={net ? "3 2" : "0"} />
      {!net && <circle cx="50" cy="75" r="10" fill="none" stroke={LINE} strokeWidth="1" />}
      {sport === "basketball" && (
        <>
          <rect x="35" y="5" width="30" height="26" fill="none" stroke={LINE} strokeWidth="1" />
          <rect x="35" y="119" width="30" height="26" fill="none" stroke={LINE} strokeWidth="1" />
          <circle cx="50" cy="14" r="6" fill="none" stroke={LINE} strokeWidth="1" />
          <circle cx="50" cy="136" r="6" fill="none" stroke={LINE} strokeWidth="1" />
        </>
      )}
    </svg>
  );
}

function CricketPitch() {
  return (
    <svg viewBox="0 0 100 150" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" style={{ background: "radial-gradient(ellipse at center,#16a34a,#15803d)" }}>
      <ellipse cx="50" cy="75" rx="46" ry="70" fill="none" stroke={LINE} strokeWidth="0.8" />
      <ellipse cx="50" cy="75" rx="30" ry="46" fill="none" stroke={LINE} strokeWidth="0.5" strokeDasharray="2 2" />
      <rect x="45" y="55" width="10" height="40" fill="rgba(210,180,140,0.55)" stroke={LINE} strokeWidth="0.5" />
    </svg>
  );
}

function GenericPitch() {
  return (
    <svg viewBox="0 0 100 150" preserveAspectRatio="none" className="absolute inset-0 w-full h-full" style={{ background: "linear-gradient(180deg,#1f2937,#111827)" }}>
      <rect x="4" y="4" width="92" height="142" fill="none" stroke={LINE} strokeWidth="0.8" />
      <line x1="4" y1="75" x2="96" y2="75" stroke={LINE} strokeWidth="0.8" strokeDasharray="3 2" />
      <circle cx="50" cy="75" r="10" fill="none" stroke={LINE} strokeWidth="0.8" />
    </svg>
  );
}

export default function Pitch({ sport = "soccer" }) {
  if (sport === "cricket") return <CricketPitch />;
  if (COURT.includes(sport)) return <CourtPitch sport={sport} />;
  if (FIELD.includes(sport)) return <FieldPitch />;
  return <GenericPitch />;
}
